module.exports = __webpack_public_path__ + "img/Middle_Exhibition_Logo.126ba91f.jpg";